
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 .5h42A3.5 3.5 0 0149.5 4v22a3.5 3.5 0 01-3.5 3.5H4A3.5 3.5 0 01.5 26V4A3.5 3.5 0 014 .5z","stroke":"#fff"}}),_c('path',{attrs:{"opacity":".2","d":"M28.062 15.243A9.756 9.756 0 0118.305 25c-5.39 0-9.758-4.368-9.758-9.757 0-5.39 4.367-9.758 9.756-9.758 5.39 0 9.757 4.37 9.757 9.758","fill":"#ADADAD"}}),_c('path',{attrs:{"opacity":".5","d":"M41.515 15.243A9.756 9.756 0 0131.758 25C26.368 25 22 20.632 22 15.243c0-5.39 4.367-9.758 9.756-9.758 5.39 0 9.757 4.37 9.757 9.758","fill":"#ADADAD"}})])
          )
        }
      }
    